import { apiEmpleo } from "../../util/ApiEmpleo";

export const apiMarkMineAsDelivered = async () => {
  let res = await apiEmpleo.post(`notifications/mark-mine-as-delivered`);
  return res;
};
